import React, { ReactElement } from 'react'
import { ArtData } from '@/database/art'
import { shortenAddress } from '@/utils/shortenAddress'
import { transferFeeText } from '@/utils/formatting'
import LoadImageButtonOnDemand from '@/components/LoadImageButtonOnDemand'
import VotesTooltip from '@/components/tooltips/VotesTooltip'
import Box from '@/components/boxes/Box'

const MintCard = ({
    artData,
    openModalMintCardDetails,
}: {
    artData: ArtData
    openModalMintCardDetails: (artData: ArtData) => void
}): ReactElement => {
    return (
        <div className="header-container center">
            <div key={artData.art.id} className="artwork-box">
                <div className="header-container width380">
                    <div className="react-flow-image__shadow_blue">
                        <div className="padding-five react-flow__shadow_red">
                            <LoadImageButtonOnDemand
                                id={'art' + artData.art.id}
                                alt={artData.art.prompt}
                                artData={artData}
                                style="z-index-zero"
                                onClick={() => openModalMintCardDetails(artData)}
                                fixedWidth={100}
                            />
                        </div>
                    </div>
                    <div>
                        <div className={'header-container'}>
                            <Box caption={'Title'} text={artData.art.title} />
                        </div>
                        <div className={'header-container'}>
                            <Box
                                caption={'Description'}
                                styleCaption={'small gray'}
                                styleText={'small white'}
                                text={artData.art.prompt}
                            />
                        </div>
                        <div className={'header-container'}>
                            <Box
                                caption={'Creator'}
                                styleCaption={'small gray'}
                                styleText={'small white'}
                                text={shortenAddress(artData.user.walletAddress)}
                            />
                            <Box
                                caption={'Transfer Fee'}
                                styleCaption={'small gray'}
                                styleText={'small white'}
                                text={transferFeeText(artData)}
                                textValue={artData?.art.transferFee}
                            />
                        </div>
                    </div>
                </div>
                <div>
                    <div className={'header-container'}>
                        <Box caption={'Art'} text={'#' + artData.art.id} />
                        <div id={'votes' + artData.art.id}>
                            <Box
                                caption={'Votes'}
                                styleCaption={'gradient-text bold'}
                                text={artData.claimPower.toFixed(2)}
                            />
                        </div>
                        <button
                            type="button"
                            className=" nav__medium"
                            onClick={() => openModalMintCardDetails(artData)}
                        >
                            Vote
                        </button>
                    </div>
                    <VotesTooltip artData={artData} />
                </div>
            </div>
        </div>
    )
}

export default MintCard
